/**
 * "Show more" over a list that is already in memory (#3787), where each shown
 * row costs one delivery request: rows are revealed a step at a time, so the
 * request count follows what staff asked to see. The count starts over when
 * `scope` (the work order or inspection) changes.
 */
import { useState } from 'react';

export const REVEAL_STEP = 5;

export function useRevealedCount(scope: string | undefined, total: number, step: number = REVEAL_STEP) {
  const [revealed, setRevealed] = useState<{ scope: string | undefined; count: number }>({ scope, count: step });
  const count = revealed.scope === scope ? revealed.count : step;
  return {
    visible: Math.min(count, total),
    hasMore: count < total,
    showMore: () => setRevealed({ scope, count: count + step }),
  };
}
